export enum CaseStyles {
  sentence = 'sentence',
  kebab = 'kebab',
  snake = 'snake',
}

export function toTitleCase(
  inputString: string,
  fromCaseStyle?: CaseStyles,
): string {
  if (!inputString) {
    return '';
  }

  let splitCharacter;

  switch (fromCaseStyle) {
    case CaseStyles.kebab:
      splitCharacter = '-';
      break;
    case CaseStyles.snake:
      splitCharacter = '_';
      break;
    default:
      splitCharacter = ' ';
  }

  const words: string[] = inputString.split(splitCharacter);
  const titleCaseWords: string[] = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );

  return titleCaseWords.join(' ');
}
